import { axios } from '@Root/API'

export const otherRecordsAttachments = id => {
	return axios.put(`data-pruning-other/${id}`)
}
